import React from "react"
import DatePicker from "react-multi-date-picker"
import persian from "react-date-object/calendars/persian"
import persian_fa from "react-date-object/locales/persian_fa"
import "react-multi-date-picker/styles/layouts/mobile.css"
import {TextInput} from "./index";

export default function SimpleDatePicker({label = "", ...otherProps}) {
    return (
        <div className="w-full">
            <DatePicker
                calendar={persian}
                locale={persian_fa}
                className="rmdp-mobile"
                containerStyle={{
                    width: "100%"
                }}
                render={<TextInput
                    disabled={!!otherProps.disabled}
                    classes={{
                        labelClasses: "xl:min-w-[8.375rem] xl:text-left mb-3",
                        inputClasses: "py-2.5 xl:w-[27.875rem]",
                    }}
                    required
                    rowLabel
                    readOnly
                    onChange={() => {}}
                    label={label}
                />}
                {...otherProps}

            />
        </div>
    )
}
